module.exports = __webpack_public_path__ + "img/compete.09e4f777.png";